module.exports = __webpack_public_path__ + "img/icons_32.b3a2f728.png";